import IconButton from '@components/v2/ui/IconButton/IconButton';
import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { VizRange } from '../viz.types';

interface VizRangeStepperProps {
  ranges: VizRange[];
  selectedIndex: number;
  onSelect: (index: number) => void;
}

const VizRangeStepper = ({ ranges, selectedIndex, onSelect }: VizRangeStepperProps) => (
  <Stack
    direction="row"
    sx={(theme) => ({
      alignItems: 'center',
      gap: 0.25,
      pl: 0.25,
      pr: 0.25,
      height: 28,
      flexShrink: 0,
      border: 1,
      borderColor: 'custom.border.primary',
      borderRadius: `${theme.shape.borderRadiusFull}px`,
    })}
  >
    <IconButton
      icon={ChevronLeft}
      size="small"
      sx={{ color: 'text.tertiary' }}
      disabled={selectedIndex <= 0}
      onClick={() => onSelect(selectedIndex - 1)}
    />
    <Typography variant="micro1" noWrap>
      {ranges.at(selectedIndex)?.label}
    </Typography>
    <IconButton
      icon={ChevronRight}
      size="small"
      sx={{ color: 'text.tertiary' }}
      disabled={selectedIndex >= ranges.length - 1}
      onClick={() => onSelect(selectedIndex + 1)}
    />
  </Stack>
);

export default VizRangeStepper;
